import { ChangeImpact } from '../../../types/SystemLogging.types';

export type SupportedChangeImpact = 'MAJOR' | 'MODERATE' | 'MINOR';

export const changeImpactOptions: SupportedChangeImpact[] = [
  'MAJOR',
  'MODERATE',
  'MINOR'
];

export const changeImpactStyles: Record<
  SupportedChangeImpact,
  {
    badge: string;
    hover: string;
    focus: string;
    text: string;
    stroke: string;
  }
> = {
  MAJOR: {
    badge: 'bg-rose-100',
    hover: 'hover:bg-[#FECACA]',
    focus:
      'focus:shadow-[0_1px_2px_0_rgba(0,0,0,0.05),0_0_0_2px_#FFF,0_0_0_4px_#FECACA] focus:bg-rose-100 outline-none',
    text: 'text-rose-700',
    stroke: 'stroke-rose-700'
  },
  MODERATE: {
    badge: 'bg-yellow-100',
    hover: 'hover:bg-[#FDE68A]',
    focus:
      'focus:shadow-[0_1px_2px_0_rgba(0,0,0,0.05),0_0_0_2px_#FFF,0_0_0_4px_#FDE68A] focus:bg-yellow-100 outline-none',
    text: 'text-yellow-700',
    stroke: 'stroke-yellow-700'
  },
  MINOR: {
    badge: 'bg-cyan-100',
    hover: 'hover:bg-[#A6F4DB]',
    focus:
      'focus:shadow-[0_1px_2px_0_rgba(0,0,0,0.05),0_0_0_2px_#FFF,0_0_0_4px_#A6F4DB] focus:bg-cyan-100 outline-none',
    text: 'text-cyan-700',
    stroke: 'stroke-cyan-700'
  }
};

export const normalizeChangeImpact = (
  impact?: ChangeImpact | null
): SupportedChangeImpact => {
  if (impact === 'MAJOR' || impact === 'MODERATE' || impact === 'MINOR') {
    return impact;
  }

  return 'MINOR';
};

export const getChangeImpactLabel = (impact: SupportedChangeImpact): string => {
  return impact.charAt(0) + impact.slice(1).toLowerCase();
};

type ChangeImpactBadgeProps = {
  impact?: ChangeImpact | null;
  className?: string;
};

export function ChangeImpactBadge({
  impact,
  className = ''
}: ChangeImpactBadgeProps) {
  const normalizedImpact = normalizeChangeImpact(impact);
  const styles = changeImpactStyles[normalizedImpact];

  return (
    <div
      className={`w-min px-2.5 py-0.5 rounded-[10px] text-xs leading-4 font-medium text-nowrap ${styles.badge} ${styles.text} ${className}`.trim()}
    >
      {getChangeImpactLabel(normalizedImpact)}
    </div>
  );
}
